export const isValidDomain = value => {
    const re = /((?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+)(?:[A-Z0-9-]{2,63})/i;
    const www = /^www./i;
    if (!value) {
        return false;
    }

    if (www.test(value)) {
        return false;
    }

    return re.test(value);
};

/**
 * @param {string} value
 * @returns {boolean}
 * @memberof utils
 * @desc Checks if the given value is a valid email
 * */
export const isValidEmail = value => {
    const email = /^[A-Za-z0-9!'#$%&*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!'#$%&*+/=?^_`{|}~-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,20}$/i;
    if (value) {
        return email.test(value);
    }
};

export const validate = async (rules, data) => {
    const errors = await rules(data);
    if (Object.keys(errors).length === 0) {
        return null;
    }
    return errors;
};

export const rules = validators => async (
    values,
    errors = {},
    changes = []
) => {
    for (const validator of validators) {
        const result = await validator(values, errors, changes);
        if (result) {
            if (Array.isArray(result)) {
                const [name, message] = result;
                errors[name] = message;
            } else {
                return result;
            }
        }
    }
    return errors;
};

export const month = name => values => {
    const result = /^([1-9]|1[012])$/.test(values[name]);
    return result ? null : [name, 'invalid'];
};

export const futureYear = name => values => {
    const currentYear = new Date().getFullYear();
    const value = parseInt(values[name], 10);
    if (!Number.isNaN(value) && value >= currentYear) {
        return null;
    }
    return [name, 'invalid'];
};

export const maxAllowedValue = (name, maxValue) => values => {
    const value = parseInt(values[name], 10);
    if (!Number.isNaN(value) && value <= maxValue) {
        return null;
    }
    return [name, 'Invalid input: the value exceeds the allowed limit.'];
};

export const notZeroOrNegative = name => values => {
    const value = parseFloat(values[name]);
    return value > 0 ? null : [name, 'Value must be greater than zero'];
};

export const minAllowedSeats = () => values => {
    const value = parseInt(values.seats, 10);
    const users = parseInt(values.users, 0);
    if (!Number.isNaN(value) && value >= users) {
        return null;
    }
    return [
        'seats',
        'Invalid: value cannot be less than the amount of existing users.',
    ];
};

export const notEmpty = name => values => {
    let value = values[name];
    if (typeof value === 'string') {
        value = (value || '').trim();
    } else if (typeof value === 'number') {
        value = parseInt(values[name], 10);
        if (Number.isNaN(value)) {
            value = '';
        }
    }
    return value ? null : [name, 'Required'];
};

export const notEmptyNumber = name => values => {
    let value = values[name];
    if (/^\d+$/.test(value)) {
        value = parseInt(value, 10);
        return Number.isNaN(value) || value <= 0 ? [name, 'required'] : null;
    }
    if (/^\d+\.\d+$/.test(value)) {
        value = parseFloat(value, 10);
        return Number.isNaN(value) || value <= 0 ? [name, 'required'] : null;
    }
    return [name, 'invalid'];
};

export const emailType = name => values => {
    const value = values[name];
    if (value) {
        return isValidEmail(value) ? null : [name, 'incorrect_email'];
    }
};

export const maxLength = (name, maxLen) => values => {
    const value = values[name];
    if (value && value.length > maxLen) {
        return [name, `Invalid: value must not exceed ${maxLen} characters`];
    }
    return null;
};

export const conditionCheck = (condition, rule) => async (
    values,
    errors,
    changes
) => {
    if (await condition(values, changes)) {
        return await rule(values, errors, changes);
    }
    return null;
};
